import { render } from "./OrganizationUsageSummary.vue?vue&type=template&id=18a4d115&scoped=true"
import script from "./OrganizationUsageSummary.vue?vue&type=script&lang=js"
export * from "./OrganizationUsageSummary.vue?vue&type=script&lang=js"

import "./OrganizationUsageSummary.vue?vue&type=style&index=0&id=18a4d115&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a4d115"]])

export default __exports__